export const DEV = false;

export const API_URL = DEV
    ? 'http://192.168.0.111:8081'
    // : 'https://admin.mnfansubs.net'
    : 'https://www.mnfansubs.net'

export const FAKE_API = DEV
    ? 'http://192.168.0.103:8081'
    // : 'https://admin.mnfansubs.net'
    : 'https://www.mnfansubs.net'
